import React from "react";
import AppText from '../atoms/AppText'
import AppButton from "../molecules/AppButton";
import { getWindowDimensions } from "../../HelperFunctions/index";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";

export default function NoStatus({height = 150}) {
    const screenSize = getWindowDimensions()
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const history = useHistory()

    return (
        <div className='d-flex justify-content-center w-100 align-items-center' style={{ height: screenSize.height - height }}>
            <div className={`d-flex flex-column align-items-center ${isMobile ? 'w-70' : 'w-40'}`}>
                <img alt={"message"} src='/Group-2128.svg' className={'mb-5'} height={'142'} width={'190'}></img>
                <AppText size='_18' weight='_medium' color={'_c100'}>
                    Jumping the gun here are we?
                </AppText>
                <span className={'d-flex mb-4'}>
                    <AppText size='_16' color={'_c50'} align={'_center'}>
                        When you apply for a job, the status of your progress in the job recruitment process will appear here.
                    </AppText>
                </span>
                <AppButton width='_full' type='submit' onClick={() => { history.push('/') }}>
                    <AppText color='_c0' size='_14'>
                        Find a Job
                    </AppText>
                </AppButton>
            </div>
        </div>
    )
}